// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"ParagraphLine_paragraph__rUTFO"};